import React from "react";
import { Typography } from "@mui/material/";
import { strings } from "../../../../../common/i18n";

/**
 * Why the scheduling engine made this asset non-mandatory.
 * `reason` is the API's non_mandatory_reason code (e.g. "make_filter").
 * Renders nothing for assets created before the reason was recorded.
 */
export const nonMandatoryReasonLabel = (reason) =>
    reason
        ? strings(`messages.nonMandatoryReasons.${reason}`, {
              defaultValue: reason
          })
        : null;

export default ({ reason, ...typographyProps }) => {
    const label = nonMandatoryReasonLabel(reason);
    if (!label) return null;
    return (
        <Typography variant="body2" color="inherit" {...typographyProps}>
            {strings("messages.nonMandatoryReason", { reason: label })}
        </Typography>
    );
};
